/* LEDPLANET lp-compact.js (17-10-2026): werking van snippets/ledplanet-productpagina-compact als gecacht bestand.
   De gegevens per pagina (voorraad per variant, teksten per taal) staan inline in window.LP_PP_DATA; dit bestand wordt direct daarna
   synchroon geladen, op dezelfde plek als het oude inline script (zelfde volgorde). De opmaak blijft inline in het snippet. Wijzig de werking HIER. */
(function () {
  var D = window.LP_PP_DATA || {};
  var VR = D.vr || {};
  var T = D.t || {};
  /* bedragen zonder €-teken, net als de hoofdprijs */
  function geld(v) { try { return new Intl.NumberFormat('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v); } catch (e) { return v.toFixed(2).replace('.', ','); } }
  function getal(t) { var s = String(t || '').replace(/[^0-9,.]/g, ''); if (/,\d{1,2}$/.test(s)) s = s.replace(/\./g, '').replace(',', '.'); else s = s.replace(/,/g, ''); return parseFloat(s) || 0; }

  /* 1. Vertrouwen onder de titel */
  function vertrouwen() {
    var titel = document.querySelector('.cc-main-product .product-info__title');
    if (!titel || document.querySelector('.lp-pp-trust')) return;
    var tpl = document.getElementById('lp-pp-trust-tpl'); if (!tpl) return;
    var a = tpl.content.firstElementChild.cloneNode(true);
    titel.insertAdjacentElement('afterend', a);
    var n = 0;
    (function kijk() {
      var el = document.querySelector('.wwk-sidebar__balloon, .wwk-sidebar-popup__rating');
      var m = el && el.textContent.match(/\b(\d{1,2}[,.]\d)\b/);
      if (m) { a.querySelector('[data-lp-pp-score]').textContent = m[1].replace('.', ','); if (window.lpSterren) window.lpSterren(m[1]); }
      else if (++n < 30) setTimeout(kijk, 500);
    })();
  }

  /* 1b. 'Ook handig': toevoegen aan winkelwagen zonder de pagina te verlaten (winkelwagen-icoon en -lade worden bijgewerkt, lade blijft dicht) */
  function ookToevoegen(e) {
    var b = e.target.closest('[data-lp-ook]'); if (!b || b.disabled) return;
    b.disabled = true;
    var lade = document.querySelector('cart-drawer');
    var secties = ['cart-icon-bubble'];
    var ls = lade && lade.closest('.shopify-section');
    if (ls) secties.push(ls.id.replace('shopify-section-', ''));
    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.getAttribute('data-lp-ook'), quantity: 1 }], sections: secties.join(','), sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.sections) {
        var ic = document.getElementById('cart-icon-bubble');
        if (ic && d.sections['cart-icon-bubble']) ic.innerHTML = d.sections['cart-icon-bubble'];
        if (lade && lade.renderContents) lade.renderContents(d, false);
      }
      try { document.dispatchEvent(new CustomEvent('on:cart:add', { detail: { variantId: +b.getAttribute('data-lp-ook') } })); } catch (x) {}
      b.classList.add('is-ok'); b.innerHTML = '&#10003;'; b.title = b.getAttribute('data-ok') || '';
      setTimeout(function () { b.disabled = false; }, 600);
    }).catch(function () { b.disabled = false; });
  }

  /* 2. Subregel onder de prijs (17-10-2026): '13,15 per stuk · incl. btw · 217,31 excl. btw' (per stuk alleen bij sets, excl. alleen NL/BE).
        'inclusief btw' van het thema verdwijnt als dat het enige is wat daar staat (andere tekst, bijv. verzendbeleid, blijft staan). */
  var BTW = /^(inclusief|inkl|incl|including|tax included|TVA|TTC|IVA|z VAT|brutto)/i;
  function prijsExtra() {
    var prijsEl = document.querySelector('.cc-main-product .product-price .price__current .js-value, .cc-main-product .price__current .js-value');
    var blok = document.querySelector('.cc-main-product .product-price');
    if (!prijsEl || !blok) return;
    var p = getal(prijsEl.textContent); if (!p) return;
    var md = document.getElementById('metafield-data');
    var stuks = parseFloat(md && md.getAttribute('data-packsize')) || 1;
    var pol = blok.querySelector('.product-policies');
    /* 17-10-2026 (4): de themaregel ('inclusief btw', 'Taxes incluses Frais de livraison calculés lors du paiement.' e.d.) in elke taal weg:
       btw staat in onze subregel en de verzending in de gratis-verzendingbalk */
    if (pol) pol.classList.add('lp-pp-btw-weg');
    /* 17-10-2026 (5): rustige volgorde zonder vet: incl. btw · excl. btw · per stuk */
    var delen = [];
    var was = document.querySelector('.cc-main-product .product-price .price__was .js-value');
    var w = was ? getal(was.textContent) : 0;
    if (T.besp && w > p) delen.push('<span class="lp-pp-besp">' + T.besp + ' ' + geld(w - p) + ' (' + Math.round((w - p) / w * 100) + '%)</span>');
    /* 02-11-2026 eigenaar: excl.-prijs klein in het groene prijsvak (NL/BE); elders 'incl. btw' in de subregel */
    var vak = blok.querySelector('.price');
    var ex = vak && vak.querySelector('.lp-pp-excl');
    if (T.toonExcl && vak) {
      var et = geld(p / 1.21) + ' ' + T.excl;
      if (!ex) { ex = document.createElement('span'); ex.className = 'lp-pp-excl'; vak.appendChild(ex); }
      if (ex.textContent !== et) ex.textContent = et;
    } else {
      if (ex) ex.remove();
      delen.push('<span>' + T.incl + '</span>');
    }
    /* 02-11-2026 eigenaar: prijs per stuk alleen bij sets zonder verpakkingstegels (de tegels tonen de prijs per stuk al) */
    if (stuks > 1 && !document.getElementById('lp-verp')) delen.push('<span class="lp-pp-stuk">' + geld(p / stuks) + ' ' + T.stuk + '</span>');
    var x = blok.querySelector('.lp-pp-sub');
    if (!x) {
      x = document.createElement('div'); x.className = 'lp-pp-sub';
      var pr = blok.querySelector('.product-info__price');
      if (pr) pr.insertAdjacentElement('afterend', x); else blok.appendChild(x);
    }
    var html = delen.join('<i>·</i>');
    if (x.innerHTML !== html) x.innerHTML = html;
  }

  /* 4. Voorraad + levertijd direct boven de knop (levertijdtekst komt uit de eerste USP-regel) */
  var VINK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
  function variantId() {
    var i = document.querySelector('.cc-main-product form[action*="/cart/add"]:not(.js-instalments-form) [name="id"], .cc-main-product [name="id"]');
    return i && i.value;
  }
  function levRegel() {
    return [].slice.call(document.querySelectorAll('#productUSPs li')).filter(function (li) { return /levertijd|bestel|in huis|lieferzeit|bestellt|delivery|ordered|livraison|command|entrega|pedido|consegna|ordin|dostaw|zam[oó]w/i.test(li.textContent); })[0];
  }
  /* Beknopte levertijd naast de voorraadstatus (01-10-2026): 'Op voorraad - morgen in huis met PostNL' of '1 - 3 werkdagen met DPD';
     zonder 'Nu bestellen =' en zonder de tooltip. De dag/datum komt uit de levertijd-motor (per land/taal). */
  function kort(t) {
    var c = t.cloneNode(true);
    [].forEach.call(c.querySelectorAll('.delivery-info-icon, [class*="tooltip"], [class*="info"]'), function (x) { x.remove(); });
    var tx = (c.textContent || '').replace(/\s+/g, ' ').replace(/ⓘ.*$/, '').trim();
    var w = tx.match(/\d+\s*-\s*\d+\s*(werkdagen|Werktage|working days|jours ouvr\S*|d[ií]as (laborables|h[aá]biles)|giorni lavorativi|dni robocz\S*)/i);
    var d = tx.match(/\b(vandaag|morgen|overmorgen|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag|zondag|\d{1,2} (januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december))\b/i);
    var v = tx.match(/\b(met|mit|with|avec|con|z)\s+(PostNL|DPD|DHL|GLS|UPS)\b/i);
    var uit;
    if (w) uit = w[0];
    else if (d && /in huis/i.test(tx)) uit = d[1] + ' in huis';
    else if (tx.indexOf('=') > -1) uit = tx.split('=')[1].replace(/\s+(met|mit|with|avec|con|z)\s+(PostNL|DPD|DHL|GLS|UPS)\b.*$/i, '').trim();
    else uit = tx;
    if (v && uit.indexOf(v[2]) === -1) uit += ' ' + v[0];
    return uit.charAt(0).toLowerCase() + uit.slice(1);
  }
  /* Voorraadregel (17-10-2026): echte bezorgdatum uit de centrale levertijd (LP_LEVERTIJD.productRegel), anders de oude USP-tekst.
     Staat de datum al in de gratis-verzendingregel (html.lp-gv-datum), dan hier alleen 'Op voorraad · verzending met PostNL'. */
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function voorraad() {
    var blok = document.querySelector('.cc-main-product .product-price');
    if (!blok) return;
    var st = VR[variantId()];
    var el = document.querySelector('.lp-pp-stock');
    /* 17-10-2026 (3): voorraad + levertijd staan in de gratis-verzendingbalk (ledplanet-gratis-verzending); dan hier geen eigen regel */
    /* 23-10-2026 eigenaar: compacte regel 'Op voorraad · bestel binnen …, morgen in huis met PostNL' weer direct boven de bestelknop;
       de groene balk (onderaan bij de USP's) toont dan alleen nog gratis verzending */
    if (window.LP_GV_ACTIEF && !document.querySelector('.cc-main-product #productUSPs')) { if (el) el.remove(); var lv0 = levRegel(); if (lv0) lv0.classList.add('lp-pp-verplaatst'); return; }
    if (!st) { if (el) el.remove(); var li0 = document.querySelector('.lp-pp-verplaatst'); if (li0) li0.classList.remove('lp-pp-verplaatst'); return; }
    if (!el) {
      el = document.createElement('div'); el.className = 'lp-pp-stock';
      var verp = document.getElementById('lp-verp');
      (verp && verp.previousElementSibling === blok ? verp : blok).insertAdjacentElement('afterend', el);
    }
    var li = levRegel(), lev = '', r = null;
    if (li) li.classList.add('lp-pp-verplaatst');
    try { r = window.LP_LEVERTIJD && window.LP_LEVERTIJD.productRegel && window.LP_LEVERTIJD.productRegel(); } catch (e) {}
    if (r && r.tekst) {
      if (document.documentElement.classList.contains('lp-gv-datum')) lev = esc(r.verzending);
      else lev = esc(/^de/i.test(T.locale) ? r.tekst : r.tekst.charAt(0).toLowerCase() + r.tekst.slice(1)) + esc(r.met) + (r.klein ? ' <small>' + esc(r.klein) + '</small>' : '');
    } else if (li) { var t = li.querySelector('.usp-text'); lev = t ? esc(kort(t)) : ''; }
    var html = VINK + '<span>' + (st === 1 ? T.op : T.lev) + (lev ? '<span class="lp-pp-lev">' + lev + '</span>' : '') + '</span>';
    if (el.innerHTML !== html) el.innerHTML = html;
  }

  /* 5. Korte specificaties onder de bestelknop */
  function specs() {
    if (document.querySelector('.lp-pp-specs')) return;
    var tpl = document.getElementById('lp-pp-specs-tpl');
    if (!tpl || !tpl.content.firstElementChild) return;
    var knop = document.querySelector('.cc-main-product button[name="add"], .cc-main-product .product-info__add-button, .cc-main-product form[action*="/cart/add"]:not(.js-instalments-form)');
    var blok = knop && (knop.closest('.product-info__block') || knop.closest('form'));
    if (!blok) return;
    var d = tpl.content.firstElementChild.cloneNode(true);
    [].forEach.call(d.querySelectorAll('[data-lp-lm]'), function (b) { var n = parseInt(b.textContent.replace(/\D/g, ''), 10); if (n) b.textContent = n.toLocaleString('nl-NL') + ' lm'; });
    var oo = document.querySelector('.lp-pp-ook');
    (oo || blok).insertAdjacentElement('afterend', d);
    /* 02-11-2026 eigenaar: geen losse link 'Alle specificaties' meer (dubbel); de tegels zelf openen de specificaties */
    d.addEventListener('click', function () {
      var s = [].slice.call(document.querySelectorAll('.cc-product-details summary')).filter(function (x) { return /specific|technisch|caract|specyf|dane/i.test(x.textContent); })[0];
      if (!s) return;
      var det = s.closest('details'); if (det && !det.open) s.click();
      setTimeout(function () { s.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
    });
  }

  /* 5b. 'Ook handig' (23-10-2026): direct onder aantal + bestelknop, boven de korte specificaties */
  function ookHandig() {
    if (document.querySelector('.lp-pp-ook')) return;
    var ot = document.getElementById('lp-pp-ook-tpl');
    if (!ot || !ot.content.firstElementChild) return;
    var knop = document.querySelector('.cc-main-product button[name="add"], .cc-main-product .product-info__add-button, .cc-main-product form[action*="/cart/add"]:not(.js-instalments-form)');
    var blok = knop && (knop.closest('.product-info__block') || knop.closest('form'));
    if (!blok) return;
    var ook = ot.content.firstElementChild.cloneNode(true);
    var sp = document.querySelector('.lp-pp-specs');
    if (sp) sp.insertAdjacentElement('beforebegin', ook); else blok.insertAdjacentElement('afterend', ook);
    ook.addEventListener('click', ookToevoegen);
  }

  /* 6. Fotobolletjes onder de foto (telefoon) */
  function bolletjes() {
    var viewer = document.querySelector('.cc-main-product .product-media .media-viewer');
    var kader = viewer && viewer.closest('.media-gallery__viewer');
    if (!viewer || !kader) return;
    var items = [].slice.call(viewer.children).filter(function (li) { return getComputedStyle(li).display !== 'none'; });
    var d = document.querySelector('.lp-pp-dots');
    if (items.length < 2) { if (d) d.remove(); return; }
    if (d && d.children.length === items.length) return;
    if (d) d.remove();
    d = document.createElement('div'); d.className = 'lp-pp-dots';
    items.forEach(function (li, i) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', (i + 1) + ' / ' + items.length);
      b.addEventListener('click', function () { viewer.scrollTo({ left: li.offsetLeft - items[0].offsetLeft, behavior: 'smooth' }); });
      d.appendChild(b);
    });
    kader.insertAdjacentElement('afterend', d);
    function actief() {
      var x = viewer.scrollLeft, beste = 0, afst = 1e9;
      items.forEach(function (li, i) { var a = Math.abs(li.offsetLeft - items[0].offsetLeft - x); if (a < afst) { afst = a; beste = i; } });
      [].forEach.call(d.children, function (b, i) { b.classList.toggle('is-actief', i === beste); });
    }
    if (!viewer.lpDots) { viewer.lpDots = true; viewer.addEventListener('scroll', function () { clearTimeout(viewer.lpT); viewer.lpT = setTimeout(actief, 60); }, { passive: true }); }
    actief();
  }

  /* 3. Leeg reviewblok verbergen */
  var LEEG = /(wees de eerste|be the first|sei der erste|seien sie der erste|soyez le premier|s[ée] el primero|sii il primo|b[aą]d[zź] pierwsz)/i;
  function reviews() {
    var w = document.getElementById('judgeme_product_reviews');
    if (!w) return;
    var blok = w.closest('.product-details__block') || w.parentElement;
    if (LEEG.test(w.innerText || '')) blok.classList.add('lp-pp-leeg'); else blok.classList.remove('lp-pp-leeg');
  }

  /* 7. Telefoon: aantal + knop naast elkaar; past de knoptekst niet, dan aantal erboven (17-10-2026 (6)) */
  var SMAL = window.matchMedia('(max-width: 768.98px)');
  function knopRij() {
    var rij = document.querySelector('.cc-main-product .product-info__add-to-cart');
    if (!rij) return;
    rij.classList.remove('lp-pp-stapel', 'lp-pp-klein');
    if (!SMAL.matches) return;
    var b = rij.querySelector('button[name="add"]');
    if (!b) return;
    /* breedte van de tekst zelf meten (scrollWidth van een knop is niet betrouwbaar); eerst 13px, dan 12px, anders stapelen */
    function past() {
      var r = document.createRange(); r.selectNodeContents(b);
      var cs = getComputedStyle(b), ruimte = b.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      return r.getBoundingClientRect().width <= ruimte + 1;
    }
    if (past()) return;
    rij.classList.add('lp-pp-klein');
    if (past()) return;
    rij.classList.remove('lp-pp-klein'); rij.classList.add('lp-pp-stapel');
  }

  /* 23-10-2026 eigenaar: prijsvak in hetzelfde groen als de bestelknop, dunne witte cijfers, strakker om de prijs */
  function prijsStijl() {
    if (document.getElementById('lp-pp-prijs-css')) return;
    var s = document.createElement('style'); s.id = 'lp-pp-prijs-css';
    s.textContent = '.cc-main-product .product-price .price{background:#0DA44A!important;padding:4px 12px!important;border-radius:8px!important;display:inline-block}'
      + '.cc-main-product .product-price .price__current,.cc-main-product .product-price .price__current .js-value{color:#fff!important;font-weight:500!important}'
      + '.cc-main-product .product-price .price__was,.cc-main-product .product-price .price__was .js-value{color:rgba(255,255,255,.78)!important;font-weight:400!important}'
      + '.lp-pp-sub .lp-pp-stuk{color:#123847;font-weight:600}'
      + '.lp-pp-sub:empty{display:none!important}'
      + '.cc-main-product .product-price .price{flex-wrap:wrap}'
      + '.cc-main-product .product-price .price .lp-pp-excl{display:block;flex-basis:100%;width:100%;margin:1px 0 0;font-family:Poppins,sans-serif;font-size:12px;font-weight:400;line-height:1.25;color:rgba(255,255,255,.88)!important;white-space:nowrap}';
    document.head.appendChild(s);
  }
  function start() {
    prijsStijl();
    vertrouwen(); prijsExtra(); reviews(); ookHandig(); specs(); voorraad(); bolletjes(); knopRij();
    var tmr; window.addEventListener('resize', function () { clearTimeout(tmr); tmr = setTimeout(knopRij, 150); });
    var prijs = document.querySelector('.cc-main-product .product-price');
    if (prijs && window.MutationObserver) new MutationObserver(function () { prijsExtra(); voorraad(); }).observe(prijs, { childList: true, subtree: true, characterData: true });
    var usps = document.getElementById('productUSPs');
    if (usps && window.MutationObserver) new MutationObserver(function () { voorraad(); }).observe(usps, { childList: true, subtree: true, characterData: true });
    ['lp:levertijd-tik', 'lp:levertijd-update', 'lp:gv-datum'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(voorraad, 20); }); });
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('.cc-main-product')) { setTimeout(voorraad, 150); setTimeout(bolletjes, 400); setTimeout(knopRij, 300); } });
    [1000, 2500, 5000].forEach(function (t) { setTimeout(reviews, t); setTimeout(voorraad, t); setTimeout(ookHandig, t); setTimeout(specs, t); setTimeout(bolletjes, t); setTimeout(knopRij, t); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
